import React from 'react';
import { Link } from 'react-router-dom';

const RichText = ({ data }) => {
    // This component renders Strapi 5 Rich Text (Blocks)
    if (!data || !data.description) return null;

    const renderChildren = (children) => {
        if (!children || !Array.isArray(children)) return null;
        return children.map((child, idx) => {
            if (child.type === 'text') {
                let element = <span key={idx}>{child.text}</span>;
                if (child.bold) element = <strong key={idx}>{element}</strong>;
                if (child.italic) element = <em key={idx}>{element}</em>;
                if (child.strikethrough) element = <del key={idx}>{element}</del>;
                if (child.underline) element = <u key={idx}>{element}</u>;
                if (child.code) element = <code key={idx}>{element}</code>;
                return element;
            }
            if (child.type === 'link') {
                return (
                    <Link key={idx} to={child.url} target="_blank" rel="noopener noreferrer">
                        {renderChildren(child.children)}
                    </Link>
                );
            }
            return null;
        });
    };

    const renderBlock = (block, idx) => {
        if (!block) return null;

        switch (block.type) {
            case 'paragraph':
                return <p key={idx}>{renderChildren(block.children)}</p>;
            case 'heading':
                const Tag = `h${block.level || 2}`;
                return <Tag key={idx}>{renderChildren(block.children)}</Tag>;
            case 'list':
                const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
                return (
                    <ListTag key={idx}>
                        {block.children.map((item, i) => (
                            <li key={i}>{renderChildren(item.children)}</li>
                        ))}
                    </ListTag>
                );
            case 'quote':
                return <blockquote key={idx}>{renderChildren(block.children)}</blockquote>;
            case 'code':
                return (
                    <pre key={idx}>
                        <code>{renderChildren(block.children)}</code>
                    </pre>
                );
            default:
                return null;
        }
    };

    return (
        <section className="privacy-policy-area ptb-60">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-12">
                        <div className="privacy-policy-content">
                            {Array.isArray(data.description) ? data.description.map(renderBlock) : null}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RichText;
